import { getDropdownItemsFromStatusConfig } from 'shared/ui/Status'
import { tollFreeStatusConfig } from 'entities/Compliance/ui/TollFreeStatus/config'

export const tollFreeStatusesDropdownItems = getDropdownItemsFromStatusConfig(tollFreeStatusConfig)
